<template>
	<div>
				<div class="select-block">
					<div id="ToolChart"></div>
				</div>
	</div>
</template>

<script>
	import "echarts/map/js/china.js"
	import Api from "../../Serves/net-api.js";
	import Http from "../../Serves/net-http.js";
	import { mapState, mapActions, mapMutations } from "vuex";
	export default {
		name: "HarvestStatisticsByTime",
		components: {
		},
		data() {
			return {
				tabValue:'0',
				Citychars: "",
        itemList: [],
				njNumList: [],
				njNumList2: [],
				activeNames: '全部机具',
        tabDataList: [],
        njClassName: ''
			}
		},
		mounted() {
      this.init()
     this.statisticsNjNumAndWorkAreaByArea()
		},
		methods: {
			init() {
				setTimeout(() => {
					window.addEventListener("resize", () => {
						this.Citychars.resize()
					})
				}, 30)
			},
		
		
      // 请求作业面积
		
      // 请求图表数据
			statisticsNjNumAndWorkAreaByArea() {
				var parmse = {
					
				}
				var url = Http.test + '/screenBuyNj/getAreaStatisticHarvesterByDate'
				Api.doPost(url, parmse, false, res => {
					this.tabDataList = res.result
					this.getdata(res.result)
				})
			},
			getdata(data) {
				
				var totalArr = data.map(item => {
					return item.njNum
				})
				var totalAreaArr = data.map(item => {
					return item.totalArea
				})
				var nameArr = data.map(item => {
					return item.workDate
				})
				
				
				this.Citychars = this.$echarts.init(document.getElementById('ToolChart'))
				this.Citychars.setOption({
					// backgroundColor: '#0B1640',
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross',
							label: {
								backgroundColor: '#0B1640'
							}
						}
					},
					legend: {
						data: ['农机数量', '收获面积'],
						top: '0', // 距离容器上边界40像素
						textStyle: {
							color: '#ffffff',
							fontSize: 14
						}
					},
					grid: {
						top: '15%', // 距离容器上边界40像素
						bottom: '15%', // 距离容器下边界30像素
						left: 60,
						right: 100,
					},
					dataZoom: [
						//X轴滑动条
						{
							type: 'slider', //滑动条
							// show: this.groupType === 1 ? true : false, //开启
							show: this.tabDataList.length > 20 ? true : false, //开启
							xAxisIndex: [0],
							left: '4%', //滑动条位置
							bottom: '3%',
							start: 0, //初始化时，滑动条宽度开始标度
							end: this.tabDataList.length > 20 ? 50 : 100 //初始化时，滑动条宽度结束标度
						},
						//X轴内置滑动
						{
							type: 'inside', //内置滑动，随鼠标滚轮展示
							xAxisIndex: [0],
							start: 1, //初始化时，滑动条宽度开始标度
							end: 100 //初始化时，滑动条宽度结束标度
						}
					],
					xAxis: [{
						type: 'category',
						axisLabel: {
							color: '#C8C7DD',
							// fontSize: 14,
							// rotate: 45
							// fontWeight: 'bold'
						},
						axisLine: {
							lineStyle: {
								color: '#dddddd'
							},
							width: 5
						},
						axisTick: {
							show: false
						},
						data: nameArr
						// data: ['山东省', '湖南省', '上海市', '北京市', '天津市', '福建省', '湖北省', '河北省', '河南省']
					}],
					yAxis: [
						{
							type: 'value',
							value: 1,
							name: '单位：台',
							position: 'left',
							nameTextStyle: {
								color: '#C8C7DD'
							},
							axisLabel: {
								show: true,
								color: '#C8C7DD',
								formatter: '{value}'
							},
							axisLine: {
								show: false,
								lineStyle: {
									color: '#dddddd'
								},
								width: 5
							},
							axisTick: {
								show: false
							},
							splitLine: {
								show: false,
								lineStyle: {
									width: 0.2,
									type: 'dashed',
									color: '#e9e9e9'
								}
							}
						},
						{
							type: 'value',
							name: '单位：亩',
							position: 'right',
							nameTextStyle: {
								color: '#C8C7DD'
							},
							axisLabel: {
								show: true,
								color: '#C8C7DD',
								formatter: '{value}'
							},
							axisLine: {
								show: false,
								lineStyle: {
									color: '#dddddd'
								},
								width: 5
							},
							axisTick: {
								show: false
							},
							splitLine: {
								lineStyle: {
									// type: 'dashed',
									color: 'rgba(150, 164, 244, 0.3)'
								}
							}
						}
					],
					series: [{
							name: '农机数量',
							type: 'bar',
							barWidth: 25,
							color: "#4992FF",
							// xAxisIndex: 1,
							// yAxisIndex:1,
							// position:'left',
							data: totalArr
							// data: [2000.56, 33235, 45664, 4584, 8978, 1239, 45646, 4586, 74841]
						},
						{
							name: '收获面积',
							type: 'line',
							yAxisIndex: 1,
							color: '#ff6d00',
							data: totalAreaArr
							// data: [123, 456, 231, 321, 213, 421, 623, 95, 100]
						}
					]
				})
			},
			
			timeFormat(date) {
				if(!date || typeof date === 'string') {
					this.error('参数异常，请检查...')
				}
				var y = date.getFullYear() // 年
				// this.yearValue = y
				var m = date.getMonth() + 1 // 月
				var d = date.getDate() // 日
				if(m >= 1 && m <= 9) {
					m = '0' + m
				}
				if(d >= 1 && d <= 9) {
					d = '0' + d
				}
				return y + '-' + m + '-' + d
			},
			// 获取本年第一个月
			getFirstDayOfYear(date) {
				date.setDate(1)
				date.setMonth(0)
				return this.timeFormat(date)
			},
			// 获取当前日期
			getNowFormatDates() {
				var date = new Date()
				// var seperator1 = '-'
				var year = date.getFullYear()
				var month = date.getMonth() + 1
				var strDate = date.getDate()
				if(month >= 1 && month <= 9) {
					month = '0' + month
				}
				if(strDate >= 0 && strDate <= 9) {
					strDate = '0' + strDate
				}
				// var currentdate = year + seperator1 + month + seperator1 + strDate
				var currentdate = year + '年' + month + '月' + strDate + '日'
				return currentdate
			}
		}
	};
</script>
<style scoped>
	/*p {
		color: #fff;
	}
	*/
	.toolStatistics {
		width: 100%;
		height: 72vh;
	}
	
	.charts-box {
		width: 98%;
		background-image: url('/static/img/zuoyejindu-bg.png');
		background-size: 100% 100%;
		background-repeat: no-repeat;
		position: relative;
		height: 74.5vh;
		/* height: 80vh; */
		margin-left: 1%;
	}
	
	/* @media screen and (max-width: 1540px) {
		.charts-box {
			height: 89vh;
		}
	}
	
	.select-block-pro {
		width: 100%;
		height: 70vh;
	} */
	
	.select-block {
		width: 100%;
		height: 55vh;
	}
	
	#ToolChart {
		width: 100%;
		height: 60vh;
		margin-left: 1%;
	}
	
	.tab-box {
		width: 96%;
		margin-left: 2%;
		/* margin-bottom: 10px; */
		/* margin-top: 20px; */
		/* display: flex; */
	}
	
	.tab-boxs {
		width: 98%;
		margin-left: 1%;
		display: flex;
		/* background: #0B1640; */
		    padding-top: 1vh;
		/* justify-content: space-between; */
	}
	
	.tablist_box {
		width: 100%;
	}
	
	.tablist_item {
		width: 100%;
		display: flex;
		position: relative;
		margin-top: -14px;
		/* padding-left: 20px; */
	}
	
	.nums {
		width: 75%;
		display: flex;
		margin-top: 10px;
		color: #439BFF;
	}
	
	.item-nums {
		width: 15%;
	}
	/*.item-nums:nth-child(1){
    margin-right: 4vw;
    padding-left: 1vw;
  }
  .item-nums:nth-child(2){
    margin-right: 5vw;
  }
  .item-nums:nth-child(3){
    margin-right: 2.5vw;
  }*/
	
	.item-nums span:nth-child(2) {
		font-size: 0.8vw;
	}
	
	.item-nums span:nth-child(1) {
		font-size: 1.3vw;
	}
	
	.item-numss {
		width: 9.7%;
		width: 15%;
	}
	
	.item-numss:nth-child(1) {
		margin-right: 4vw;
		padding-left: 1vw;
	}
	
	.item-numss:nth-child(2) {
		margin-right: 5vw;
	}
	
	.item-numss:nth-child(3) {
		margin-right: 2.5vw;
	}
	
	.item-numss span:nth-child(2) {
		font-size: 0.8vw;
	}
	
	.item-numss span:nth-child(1) {
		font-size: 1.3vw;
	}

	
</style>


// WEBPACK FOOTER //
// src/components/TableList/HarvestStatisticsByTime.vue